export const siteNav = [
  { label: '首页', href: '#top', active: true },
  { label: '评论区', href: '#comments' },
  { label: '吃瓜帖', href: '#feed' },
  { label: '合集索引', href: '#collections' },
  { label: '热议风向', href: '#trending' },
];

export const tickerItems = [
  '综艺现场疑似翻车，导演组连夜剪辑引逐帧分析',
  '同款造型三人穿，造型师评论区被围到关评',
  '直播口误三连，主播表情包一夜刷屏',
  '代言海报疑似换脸，品牌凌晨悄悄改图',
  '后援会深夜公告措辞反复，网友喊话给个说法',
  '路透照流出，站姐修图前后对比被做成合集',
];

export const heroFeatured = {
  tag: '头条围观',
  title: '综艺收官夜疑点太多，导演组连夜剪辑的这一版被网友逐帧拆解',
  summary:
    '爱黑料网网友热议度最高的一帖。从嘉宾座位排序到字幕错位，围观现场已经整理出十几条可疑线索，评论区里两派吵到凌晨三点还没停。',
  image:
    'https://readdy.ai/api/search-image?query=Warm%20editorial%20abstract%20collage%20of%20layered%20tabloid%20paper%20cards%20and%20popcorn%20floating%20over%20a%20textured%20cream%20paper%20background%2C%20coral%20amber%20and%20deep%20tea%20green%20accents%2C%20soft%20studio%20lighting%2C%20artistic%20illustration%2C%20no%20text%2C%20no%20faces%2C%20minimal%20clean%20composition&width=1000&height=640&seq=ahll-hero-main&orientation=landscape',
  meta: '热评 2.4k · 围观 18.6w',
  author: '瓜田值守员',
  time: '12 分钟前',
};

export const heroCards = [
  {
    id: 'h1',
    tag: '造型',
    title: '爆改还是失手？同款造型三人穿，造型师评论区被围到关评',
    summary: '同框照被拼成九宫格，网友连夜做对比图。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20flat%20lay%20illustration%20of%20three%20identical%20fashion%20silhouettes%20standing%20on%20a%20warm%20cream%20studio%20backdrop%20with%20coral%20and%20amber%20paper%20cut%20shapes%2C%20editorial%20collage%20style%2C%20soft%20shadows%2C%20no%20text%2C%20no%20faces%2C%20minimal%20geometric%20composition&width=520&height=340&seq=ahll-hero-a1&orientation=landscape',
    meta: '热评 860',
  },
  {
    id: 'h2',
    tag: '直播',
    title: '口误三连上热搜，主播表情包半天做出二十个版本',
    summary: '回放片段被剪成逐句解析，评论区笑声不断。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20papercut%20illustration%20of%20warm%20amber%20speech%20bubbles%20stacked%20on%20a%20cream%20textured%20background%20with%20coral%20highlights%2C%20editorial%20collage%20aesthetic%2C%20soft%20diffused%20lighting%2C%20no%20text%2C%20no%20faces%2C%20clean%20minimal%20composition&width=520&height=340&seq=ahll-hero-a2&orientation=landscape',
    meta: '热评 1.1k',
  },
  {
    id: 'h3',
    tag: '品牌',
    title: '代言海报疑似换脸，品牌凌晨悄悄改图被截图',
    summary: '前后两版海报做重叠，边缘细节对不上。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20two%20overlapping%20poster%20frames%20in%20warm%20cream%20and%20coral%20tones%20on%20a%20textured%20paper%20surface%20with%20amber%20tape%20strips%2C%20soft%20studio%20lighting%2C%20artistic%20illustration%2C%20no%20text%2C%20no%20faces&width=520&height=340&seq=ahll-hero-a3&orientation=landscape',
    meta: '热评 640',
  },
  {
    id: 'h4',
    tag: '饭圈',
    title: '后援会深夜公告前后矛盾，网友喊话给个明确说法',
    summary: '两版公告被逐句对比，措辞改了三处。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20papercut%20illustration%20of%20a%20folded%20announcement%20letter%20and%20small%20tea%20green%20leaf%20shapes%20on%20a%20warm%20cream%20backdrop%20with%20coral%20accents%2C%20editorial%20collage%20style%2C%20soft%20shadows%2C%20no%20text%2C%20no%20faces%2C%20minimal%20composition&width=520&height=340&seq=ahll-hero-a4&orientation=landscape',
    meta: '热评 520',
  },
];

export const hotComments = [
  {
    rank: '01',
    title: '座位排序那段真的细思极恐，前后镜头里椅子是挪过的',
    summary: '逐帧对比做过之后，连地面反光的位置都对不上。',
    likes: '3820',
    tag: '综艺',
  },
  {
    rank: '02',
    title: '造型师关评之前，最后一条回复被截图了',
    summary: '那条回复已经删了，但网友备份得比谁都快。',
    likes: '2964',
    tag: '造型',
  },
  {
    rank: '03',
    title: '我算是看明白了，这波节奏起得比剪辑还快',
    summary: '早上还是夸，中午开始反转，晚上直接两派开麦。',
    likes: '2571',
    tag: '风向',
  },
  {
    rank: '04',
    title: '品牌改图这事，凌晨两点改的就别怪人截到',
    summary: '页面缓存还没刷新，老图已经在群里传疯了。',
    likes: '2140',
    tag: '品牌',
  },
  {
    rank: '05',
    title: '后援会公告读了三遍，越读越像两拨人写的',
    summary: '前半段硬气，后半段突然软化，风格断得太明显。',
    likes: '1876',
    tag: '饭圈',
  },
  {
    rank: '06',
    title: '路透照那组对比合集谁做的，给跪了',
    summary: '修图前后放一起，连背景砖缝都在举报。',
    likes: '1622',
    tag: '合集',
  },
];

export const topicCollections = [
  { name: '年度名场面合集', count: '128 帖', desc: '把全年最上头的围观现场按时间排好', tone: 'primary' },
  { name: '造型翻车实录', count: '76 帖', desc: '同框、同款、同台，翻不翻车一眼见分晓', tone: 'accent' },
  { name: '语录合集', count: '342 条', desc: '热评金句按来源归档，随翻随笑', tone: 'secondary' },
  { name: '反转向导图', count: '54 张', desc: '一天之内风向怎么倒的，一张图看完', tone: 'primary' },
  { name: '路透前后对比', count: '93 组', desc: '修图与生图并排放，细节党狂喜', tone: 'accent' },
  { name: '讨论区观察手记', count: '41 篇', desc: '记录评论区怎么从对线变成玩梗', tone: 'secondary' },
];

export const gossipFeed = [
  {
    id: 'f1',
    category: '综艺',
    title: '收官夜的镜头语言，被剪掉的那三秒去哪了',
    summary: '爱黑料网吃瓜帖里热度最高的一篇长分析，从头到尾把争议镜头过了一遍。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20abstract%20editorial%20collage%20of%20film%20strip%20frames%20and%20popcorn%20grains%20on%20a%20textured%20cream%20paper%20background%20with%20coral%20and%20amber%20accents%2C%20soft%20studio%20lighting%2C%20artistic%20illustration%2C%20no%20text%2C%20no%20faces%2C%20minimal%20clean%20composition&width=640&height=420&seq=ahll-feed-01&orientation=landscape',
    stats: '围观 12.4w · 热评 1.8k',
    time: '1 小时前',
  },
  {
    id: 'f2',
    category: '品牌',
    title: '一张海报改两次，评论区把发布时间都对齐了',
    summary: '网友把三次改图的缓存时间列成表格，结论有点意思。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20papercut%20illustration%20of%20stacked%20poster%20layers%20being%20peeled%20back%20on%20a%20warm%20cream%20backdrop%20with%20coral%20and%20tea%20green%20paper%20shapes%2C%20editorial%20collage%20aesthetic%2C%20soft%20diffused%20lighting%2C%20no%20text%2C%20no%20faces&width=640&height=420&seq=ahll-feed-02&orientation=landscape',
    stats: '围观 9.7w · 热评 1.2k',
    time: '2 小时前',
  },
  {
    id: 'f3',
    category: '直播',
    title: '回放里的三处停顿，被网友做成了时间轴',
    summary: '每一处停顿后面接的话都不太一样，粉丝和路人各有一套解读。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20of%20a%20timeline%20of%20amber%20audio%20waveform%20blocks%20on%20a%20cream%20textured%20surface%20with%20coral%20markers%2C%20editorial%20collage%20style%2C%20soft%20studio%20lighting%2C%20no%20text%2C%20no%20faces%2C%20minimal%20geometric%20composition&width=640&height=420&seq=ahll-feed-03&orientation=landscape',
    stats: '围观 8.1w · 热评 980',
    time: '3 小时前',
  },
  {
    id: 'f4',
    category: '路透',
    title: '站姐生图与修图并排，背景砖缝成了最强证据',
    summary: '这组合集在评论区被反复搬运，做图的人已被网友封为细节侠。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20two%20side%20by%20side%20photo%20frames%20in%20warm%20cream%20and%20amber%20tones%20on%20a%20textured%20wall%20surface%20with%20coral%20tape%2C%20soft%20shadows%2C%20artistic%20illustration%2C%20no%20text%2C%20no%20faces&width=640&height=420&seq=ahll-feed-04&orientation=landscape',
    stats: '围观 7.6w · 热评 870',
    time: '5 小时前',
  },
  {
    id: 'f5',
    category: '讨论区',
    title: '从对线到玩梗，一个讨论帖的四小时变形记',
    summary: '前半程吵得凶，后半程全在接梗，观察手记写得挺细。',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20papercut%20illustration%20of%20overlapping%20chat%20bubbles%20in%20coral%20amber%20and%20tea%20green%20on%20a%20cream%20textured%20background%2C%20editorial%20collage%20aesthetic%2C%20soft%20diffused%20lighting%2C%20no%20text%2C%20no%20faces%2C%20clean%20minimal%20composition&width=640&height=420&seq=ahll-feed-05&orientation=landscape',
    stats: '围观 6.3w · 热评 760',
    time: '6 小时前',
  },
  {
    id: 'f6',
    category: '饭圈',
    title: '应援物料撞设计，两拨人各自晒了草图时间',
    summary: '草图时间一对，谁先谁后又成了新的话题点。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20sketch%20papers%20and%20ribbon%20shapes%20in%20warm%20cream%20amber%20and%20deep%20green%20tones%20on%20a%20textured%20desk%20surface%2C%20soft%20studio%20lighting%2C%20artistic%20illustration%2C%20no%20text%2C%20no%20faces&width=640&height=420&seq=ahll-feed-06&orientation=landscape',
    stats: '围观 5.8w · 热评 640',
    time: '8 小时前',
  },
];

export const commentSpotlight = [
  {
    user: '瓜田里的猫',
    initial: '瓜',
    level: '围观 6 级',
    content:
      '爱黑料网评论区的效率是真的高，我还在看第一版截图，人家已经做出前后对比图了，跟不上跟不上。',
    topic: '综艺收官夜',
    likes: '1.2k',
  },
  {
    user: '细节控本人',
    initial: '细',
    level: '围观 8 级',
    content:
      '座位那段的推导其实站得住，地面反光的位置前后不一样，这个细节没人提我还真没注意到。',
    topic: '逐帧分析',
    likes: '964',
  },
  {
    user: '冷静吃瓜中',
    initial: '冷',
    level: '围观 5 级',
    content:
      '不站队，就等一个时间线。现在两边各说各的，把改图时间对齐了比吵十页都有用。',
    topic: '品牌改图',
    likes: '812',
  },
  {
    user: '表情包仓库主',
    initial: '包',
    level: '围观 7 级',
    content:
      '口误那三连已经进我的收藏夹了，二十个版本我存了十九个，剩下那个画质太糊。',
    topic: '直播口误',
    likes: '748',
  },
];

export const trendingTopics = [
  { label: '综艺收官夜', heat: '18.6w', trend: 'up' },
  { label: '造型同款对比', heat: '12.4w', trend: 'up' },
  { label: '海报改图时间线', heat: '9.7w', trend: 'flat' },
  { label: '直播口误合集', heat: '8.1w', trend: 'up' },
  { label: '站姐生图对比', heat: '7.6w', trend: 'down' },
  { label: '后援会公告', heat: '6.9w', trend: 'flat' },
  { label: '讨论区观察', heat: '6.3w', trend: 'up' },
  { label: '应援物料撞设计', heat: '5.8w', trend: 'down' },
  { label: '剪辑逐帧拆解', heat: '5.1w', trend: 'up' },
  { label: '热评金句归档', heat: '4.7w', trend: 'flat' },
];

export const siteFooterLinks = [
  {
    title: '逛站指南',
    links: ['评论区入口', '吃瓜帖广场', '合集索引', '热议风向榜', '围观现场'],
  },
  {
    title: '内容分区',
    links: ['综艺', '影视', '品牌', '饭圈', '路透'],
  },
  {
    title: '站务信息',
    links: ['关于爱黑料网', '内容规范', '纠错反馈', '联系我们'],
  },
];